import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';
import { InstagramIcon, LinkedInIcon, TelegramIcon } from '../components/SocialIcons.js';

const socialLinks = [
    { Icon: InstagramIcon, label: 'Instagram', href: '#', bg: 'linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)' },
    { Icon: LinkedInIcon, label: 'LinkedIn', href: '#', bg: '#0a66c2' },
    { Icon: TelegramIcon, label: 'Telegram', href: '#', bg: '#26A5E4' },
];

const ContactSection = () => (
    <section id="contact" className="min-h-screen flex flex-col justify-center bg-brand-black text-brand-cream py-16 sm:py-20 px-5 sm:px-8 md:px-16">
        <div className="max-w-4xl mx-auto w-full text-center">
            <AnimatedElement>
                <h2 style={{ fontFamily: 'pinar', fontSize: 'clamp(24px, 4.5vw, 40px)' }}>
                    <span className="text-white">راه‌های ارتباطی </span>
                    <span style={{ color: '#ff2a3f' }}>با ما:</span>
                </h2>
            </AnimatedElement>

            <AnimatedElement delay={200} className="mt-6">
                <p
                    className="text-white text-lg md:text-xl leading-relaxed"
                    style={{ fontFamily: 'pinar', textAlign: 'justify', textAlignLast: 'center', direction: 'rtl' }}
                >
                    اگر می‌خواهید بخشی از جریان ما باشید و از فرصت‌های واقعی و حرفه‌ای تجربه کنید، از همین‌جا مسیر همکاری را آغاز کنید.
                </p>
            </AnimatedElement>

            <AnimatedElement delay={400} className="mt-10 flex items-center justify-center gap-6">
                {socialLinks.map(({ Icon, label, href, bg }) => (
                    <a
                        key={label}
                        href={href}
                        aria-label={label}
                        className="w-14 h-14 rounded-2xl flex items-center justify-center transition-transform hover:scale-110"
                        style={{ background: bg }}
                    >
                        <Icon className="w-7 h-7 text-white" />
                    </a>
                ))}
            </AnimatedElement>
        </div>
    </section>
);

export default ContactSection;
